<template>
  <div
    class="mt-3 d-flex border stats"
    :class="{'all-responsive': props.length > 3, 'small-responsive': props.length <= 3}"
  >
    <div
      class="stats-wrapper d-flex w-100"
    >
      <stats-item
        v-for="(prop, index) in props"
        :key="index"
        :index="index"
        :prop="prop"
        :props="props"
        :stats="stats"
        :disabled="disabled"
      />
      <slot />
    </div>
  </div>
</template>

<script>
import {percDiff} from '@/analytics/utils/data-analyser-utils'

import StatsItem from './StatsItem'

export default {
  components: {
    StatsItem,
  },
  props: {
    data: {
      type: Object,
      default: function () {
        return {}
      },
    },
    props: {
      type: Array,
      required: true,
    },
    minWidth: {
      type: Number,
      default: 600,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      stats: null,
      keys: [
        'emailDelivers',
        'emailOpens',
        'downloads',
        'emailClicks',
        'emailNewsletterViews',
        'emailNewsletterReads',
        'sendgridClicked',
        'sendgridOpened',
        'sendgridProcessedUnique',
        'sendgridDeliveredUnique',
        'sendgridOpenedUnique',
        'sendgridClickedUnique',
        'sendgridOpenRate',
        'webViews',
        'webDownloads',
        'scrollDepth',
        'engagedMinutes',
        'engagedMinutesNewsletter',
        'engMinsArticlesRatio',
        'newArticles',
        'accountStat',
        'userStat',
      ],
    }
  },
  watch: {
    data: {
      deep: true,
      handler (data) {
        if (data && data.current) {
        console.log('hi data',data)
          const stats = {}
          for (const key in data.current) {
            if (key.includes('Stat')) {
              stats[key] = {type: key, meta: data.current[key]}
            } else if (data.current[key] > -1 && this.keys.includes(key)) {
              stats[key] = {type: key, value: data.current[key], change: data.previous ? percDiff(data.current[key], data.previous[key], false, this.$timeframe) : false}
            } else if (this.keys.includes(key)){
              stats[key] = {type: key, meta: data.current[key]}

            }
          }
          this.stats = stats
        } else {
          this.stats = null
        }
      },
    },
  },
}
</script>

<style lang="scss">
.stats {
  min-height: 140px;
  background: $stats-bg;
  border-color: $border-gray !important;
  overflow: hidden;
  &__element {
    height: 100%;
    flex: 1 1 auto;
    overflow: hidden;
    &__wrapper {
      padding-top: 24px;
      padding-left: 16px;
      padding-bottom: 24px;
      width: 100%;
      flex: 1 1 auto;
      &__custom {
        padding-left: 24px;
      }
      &.disabled {
        cursor: no-drop;
        border-color: #dfe2ee;
        background: #FBFBFB;

        div {
          color: #98a0bc !important;
          background: #FBFBFB;

        }
        .stats__element__icon {
          background: #f0f2f9;
          svg {
            fill: #98a0bc;
          }
        }
      }

    }

    &:not(:last-child) {
      border-right: 1px solid $gray-300;
    }

    .custom-stat {
      width: 100%;
      color: #1f2638;
      svg.i {
        fill: $primary;
      }
      hr {
        margin: 24px 24px 24px 0;
      }
    }
    &__icon {
      height: 48px;
      width: 48px;
      margin-right: 16px;
      border-radius: 50%;
      background: $stats-icon-bg;
      svg {
        fill: $stats-icon-color;
        margin: auto;
      }
    }

    &__data {
      flex: 1;
      color: $nav-bg;

      &__value {
        font-size: 36px;
        font-weight: 300;
        line-height: 47.3px;
      }

      &__change {
        &.positive {
          color: $green;
        }

        &.negative {
          color: $dark-red;
        }
      }

      &__label {
        font-size: 16px;
      }
    }

    .stats-wrapper {
      overflow: hidden;
    }
  }

  @media (max-width: 1440px) {
    &.all-responsive {
      min-height: 140px;
      display: block !important;
      overflow: hidden;
      flex: none !important;
      .stats-wrapper {
        display: block !important;
      }
      .stats__element {
        height: 100%;
        flex: 1 1 auto;
        overflow: hidden;
        height: 165px !important;
        width: 33.333% !important;
        float: left !important;
        flex: none !important;
        &__wrapper__custom {
          padding-top: 36px;
        }

        &:nth-child(n+0):nth-child(-n+3) {
          border-bottom: 1px solid $border-gray;
        }
        &:last-child {
          border-right: 1px solid $border-gray;
        }
        &:nth-child(n+3):nth-child(-n+3) {
          border-right: none;
        }
        &__wrapper {

        }
      }
    }
  }

  @media (max-width: 768px) {
    &.all-responsive,
    &.small-responsive {
      min-height: 140px;
      display: block !important;
      overflow: hidden;
      flex: none !important;
      .stats-wrapper {
        display: block !important;
      }
      .stats__element {
        height: 100%;
        flex: 1 1 auto;
        overflow: hidden;
        height: 165px !important;
        float: left !important;
        flex: none !important;
        width: 50% !important;
        border-bottom: 1px solid $border-gray;

        &__wrapper__custom {
          padding-left: 16px;
        }
        &:nth-child(odd),
        &:nth-child(n+3):nth-child(-n+3) {
          border-right: 1px solid $border-gray;
        }
        &:nth-child(even) {
          border-right: none !important;
        }
        &:last-child {
          border-bottom: none !important;
        }

      }
    }
  }


  @media (max-width: 576px) {
    &.all-responsive,
    &.small-responsive {
      .stats__element {
        height: 140px !important;
        width: 100% !important;
        border-right: none !important;
        border-right-width: 0 !important;
        border-bottom: 1px solid $border-gray;

        &__wrapper__custom {
          padding-left: 16px;
          padding-top: 24px;
        }
      }
    }
  }
}


@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .stats {
    &__element {
      &__icon {
        svg {
          margin-left: 1px;
        }
      }
    }
  }
}


</style>
